const state = {
  stencils: [],
  stencilsType: null,
  stencilsSide: null,
  stencilsParameters: {},
  stencilsToDestroy: [],
  stencilsToBuy: [],
};

export default state;